const generateUUID = function () {
    var d = new Date().getTime();
    if(window.performance && typeof window.performance.now === "function"){
        d += performance.now(); //use high-precision timer if available
    }
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (d + Math.random()*16)%16 | 0;
        d = Math.floor(d/16);
        return (c=='x' ? r : (r&0x3|0x8)).toString(16);
    });
    return uuid;
};

  const initWebsoket = function(){
    let uuid = generateUUID()
    var websocket = null;
    if ('WebSocket' in window) {
        //websocket = new WebSocket("ws://project.test.zjht100.com/data-server/websocket/11");
        let url = `wss://docking.xjtstc.com/websocket/${uuid}`	
        // let url = `ws://222.128.10.58:9024/websocket/${uuid}`	
        websocket = new WebSocket(url);
    }
    return websocket; 
  }
  
export default{
    generateUUID,
    initWebsoket
}